<template>
  <ul class="list-custom__table detail-navi">
      <li class="full prev" v-if="prevNextPost.nextPostNo">
          <span>다음글</span>
          <p>
              <a href="javascript:void(0);" v-if="prevNextPost.nextPostNo" @click="doPrevNext(prevNextPost.nextPostNo)">
                {{ prevNextPost.nextPostTitle }}
              </a>
          </p>
      </li>
      <li class="full next" v-if="prevNextPost.prevPostNo">
          <span>이전글</span>
          <p>
              <a href="javascript:void(0);" v-if="prevNextPost.prevPostNo" @click="doPrevNext(prevNextPost.prevPostNo)">
                {{ prevNextPost.prevPostTitle }}
              </a>
          </p>
      </li>
  </ul>
</template>

<script>
export default {
  props: {
    value: {
      type: Object
    },
    prevNextPost: {
      type: Object
    },
    board: {
      type: Object
    },
    routeDiv: {
      type: String,
    default: ''
    }
  },
  data() {
    return {
      searchParam: {
        contentNo: null,
        postNo: null,
        attcNo: null,
        originBoardNo: null,
        boardDepth: null,
      },
    }
  },
  methods: {
    doPrevNext(postNo) {
      if(postNo != null && postNo != '') {
        this.searchParam.postNo = postNo;
        const query = {...this.$route.query}
        query.postNo = postNo.toString();
        this.$router.push({query: query});
      }
    },
  }
}
</script>